<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

export default {

	page: {
		title: 'Новая компания',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader },

	data() {
		return {
			title: 'Новая компания',
			items: [],
            company_uuid: '',
            name: '',
            inn: '',
            kpp: '',
            phone: '',
            address: ''
		}
	},

	computed: {
        company_item(){
            return this.$store.getters['companies/GET_COMPANIES_ITEM'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
	},

	async mounted() {
        this.company_uuid = this.$route.params.company_uuid ? this.$route.params.company_uuid : '';
        if(this.company_uuid !== ''){

            this.title = 'Редактирование компании';
            document.title = appConfig.title + ' - ' + 'Редактирование компании';

            let data_send = {
                'uuid' : this.company_uuid
            }

            await this.$store.dispatch('companies/FETCH_COMPANIES_ITEM', data_send);

            this.name    = this.company_item.name ? this.company_item.name : '';
            this.inn     = this.company_item.inn  ? this.company_item.inn  : '';
            this.kpp     = this.company_item.kpp  ? this.company_item.kpp  : '';
            this.phone   = this.company_item.phone ? this.company_item.phone : '';
            this.address = this.company_item.address ? this.company_item.address : '';
        }
	},

	methods: {

        async saveCompany(){

            let data_send = {
                'name'    : this.name,
                'inn'     : this.inn,
                'kpp'     : this.kpp,
                'address' : this.address,
                'phone'   : this.phone
            };

            let result = '';

            if(this.company_uuid === ''){
                result = await this.$store.dispatch('companies/FETCH_COMPANIES_CREATE', data_send);
            } else {
                data_send.uuid = this.company_uuid;
                result = await this.$store.dispatch('companies/FETCH_COMPANIES_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Companies'});
            }
        }
	},
}

</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveCompany"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <b-form-group
                                        label="Название компаним"
                                        label-for="name"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="name"
                                            placeholder="Укажите название компании"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="ИНН"
                                        label-for="inn"
                                    >
                                        <b-form-input
                                            id="inn"
                                            v-model="inn"
                                            placeholder="ИНН"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="КПП"
                                        label-for="kpp"
                                    >
                                        <b-form-input
                                            id="kpp"
                                            v-model="kpp"
                                            placeholder="КПП"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Номер телефона"
                                        label-for="phone"
                                    >
                                        <b-form-input
                                            id="phone"
                                            v-model="phone"
                                            placeholder="Номер телефона"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Юридический адрес"
                                        label-for="address"
                                    >
                                        <b-form-input
                                            id="address"
                                            type="text"
                                            v-model="address"
                                            placeholder="Юридический адрес"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
	</Layout>
</template>
